import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonFadeComponent } from './skeleton-fade/skeleton-fade.component';
import { ReplenishmentCardSkeletonComponent } from './replenishment-card-skeleton/replenishment-card-skeleton.component';
import { MaterialsModule } from '@app/shared/modules/material.module';
import { UserCardSkeletonComponent } from './user-card-skeleton/user-card-skeleton.component';
import { RestrictionCardSkeletonComponent } from './restriction-card-skeleton/restriction-card-skeleton.component';

const components = [
  SkeletonFadeComponent,
  ReplenishmentCardSkeletonComponent,
  UserCardSkeletonComponent,
  RestrictionCardSkeletonComponent,
];

@NgModule({
  declarations: [...components],
  imports: [CommonModule, MaterialsModule],
  exports: [...components],
})
export class SkeletonsModule {}
